












import {RecommendationConfiguration} from "../configuration";
import {
    AdvisorNavigation,
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    Navigation,
    Prop,
    Recommendation,
    SectionType,
    Vue
} from "@zoovu/runner-browser-api";

@Component({})
export default class AdviceSearchView extends Vue {

    @Prop()
    advice: Recommendation;

    @Prop()
    sectionType: SectionType;

    @Prop()
    navigation: AdvisorNavigation;

    @Prop()
    query: string;

    @ComponentConfig(RecommendationConfiguration)
    recommendationConfiguration: RecommendationConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    get isResultsPage(): boolean {
        if (this.sectionType) return this.sectionType === SectionType.RESULTS_PAGE;
        return false;
    }

    get searchParam() {
        return this.query;
    }

    set searchParam(text: string) {
        this.advice.setQuery(text);
    }

    get currentSectionNavigation(): Navigation {
        return this.navigation.currentSection.navigation;
    }

    get shouldRedirectToResultPage(): boolean {
        return this.recommendationConfiguration.showInitialRecommendation === false
            && this.recommendationConfiguration.numberOfRecommendationPagesInQuestionnaireSection === 1
            && this.recommendationConfiguration.numberOfProductsPerQuestionnairePage === 0
            && this.sectionType !== SectionType.RESULTS_PAGE
    }

    search(): void {
        if(this.shouldRedirectToResultPage) {
            this.navigation.goToRecommendations();
        } else {
            this.advice.requestUpdate();
        }
    }
}
